import { createSlice } from "@reduxjs/toolkit"

const districtsSlice = createSlice({
  name: 'districts',
  initialState: {
    districts: null,
    errors: []
  },
  reducers: {
    fullUpdate: (state, action) => {
      return { ...state, ...action.payload }
    },
    updateDistricts: (state, action) => {
      state.districts = action.payload
    },
    updateErrors: (state, action) => {
      state.errors = action.payload
    }
  }
})

export const { fullUpdate, updateDistricts, updateErrors } = districtsSlice.actions

export default districtsSlice.reducer